import type { TargetareModificare } from "@/types/targetare";
import { formatDataOra } from "@/utils/targetareFormatting";

type IstoricModificariProps = {
  modificari: TargetareModificare[];
  numeCheie?: (cheie: string, tabel: string) => string;
  titlu?: string;
};

export function IstoricModificari({
  modificari,
  numeCheie,
  titlu = "Istoricul modificărilor",
}: IstoricModificariProps) {
  return (
    <div className="rounded-md border">
      <p className="border-b px-3 py-2 text-sm font-medium">{titlu}</p>
      {modificari.length === 0 ? (
        <p className="p-3 text-sm text-muted-foreground">
          Nicio modificare înregistrată.
        </p>
      ) : (
        <div className="max-h-80 overflow-auto">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-muted/60 text-left text-muted-foreground">
              <tr>
                <th className="px-3 py-1.5 font-medium">Când</th>
                <th className="px-3 py-1.5 font-medium">Ce</th>
                <th className="px-3 py-1.5 font-medium">Câmp</th>
                <th className="px-3 py-1.5 font-medium">Înainte</th>
                <th className="px-3 py-1.5 font-medium">După</th>
              </tr>
            </thead>
            <tbody>
              {modificari.map((m) => (
                <tr key={m.id} className="border-t align-top">
                  <td className="whitespace-nowrap px-3 py-1.5 font-mono">
                    {formatDataOra(m.modificat_la)}
                  </td>
                  <td className="px-3 py-1.5">
                    {numeCheie ? numeCheie(m.cheie, m.tabel) : m.cheie}
                    <span className="block text-muted-foreground">
                      {m.tabel}
                    </span>
                  </td>
                  <td className="px-3 py-1.5">{m.coloana}</td>
                  <td className="max-w-[320px] break-words px-3 py-1.5 text-muted-foreground">
                    {m.vechi ?? "–"}
                  </td>
                  <td className="max-w-[320px] break-words px-3 py-1.5">
                    {m.nou ?? "–"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
